export const numberWithCommas = (x) => {
    let parts = x.toFixed(2).split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts[0] + "." + (parts[1] ? parts[1] : "00"); //add 00 cents if ONLY whole number is presented
  }



// WEBPACK FOOTER //
// ./src/utils/numberFormatter.js